export { default } from './mergeClasses';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/mergeClasses/index.js
// module id = 313
// module chunks = 0